import { string } from './type-checkers.js';
const propName = string
    .type('propName');
export { propName, };
//# sourceMappingURL=prop-name.js.map